import Head from 'next/head';
import prop from 'components/BlcMeta/props.js';

const brand = 'OPENLANE';

const BlcMeta = ({
	favicon = `/images/logos/${brand}/favicon-16x16.png`,
	title = brand,
	description = 'Making Wholesale Easy',
	imageURL = `/images/logos/${brand}/favicon-96x96.png`,
	article = 'article',
	handheld = true,
	robotsMeta = false,
}) => (
	<Head>
		<meta charSet="utf-8" />
		<meta httpEquiv="X-UA-Compatible" content="IE=edge" />
		<meta name="description" content={description || `OPENLANE | ${title}`} />
		<meta property="og:type" content={article} />
		<meta property="og:title" content={title} />
		<meta property="og:site_name" content="OPENLANE US" />
		<meta property="og:image" content={imageURL} />
		<meta property="og:description" content={description} />
		<meta name="HandheldFriendly" content={handheld.toString()} />
		<meta
			name="viewport"
			content="width=device-width, height=device-height, initial-scale=1.0, minimum-scale=1.0"
		/>
		{robotsMeta && <meta name="robots" content="noindex" />}
		<link rel="icon" type="image/png" href={favicon} />
		<title>{title}</title>
	</Head>
);

BlcMeta.propTypes = prop;

export default BlcMeta;
